import { OTHER_CKBX_VAL } from "./OtherCheckboxUtils";

export const ENVIRONMENT_BUTTONS = [ 
  {
    value: 'hospital',
    label: 'Hospital or long-term care facility',
    moreInfo: ''
  },
  {
    value: 'home',
    label: 'Home',
    moreInfo: ''
  },
  {
    value: 'school',
    label: 'School',
    moreInfo: ''
  },
  {
    value: 'office',
    label: 'Office',
    moreInfo: 'Outside the home'
  },
  {
    value: 'community',
    label: 'Community',
    moreInfo: 'At places like a friend\'s house, the library, the store.'
  },
  {
    value: 'mobile',
    label: 'On the go',
    moreInfo: 'While going from place to place'
  },
  {
    value: OTHER_CKBX_VAL,
    label: 'Other',
    moreInfo: ''
  }
];

